<div class="game-container">
    <canvas #groceryCanvas class="game-cavas" width="352" height="198"></canvas>
    <app-battle class="battle" [class.display-none]="!academySvc.battleShow" ></app-battle>
    <app-text-message [class.display-none]="!academySvc.textMessageShow"></app-text-message>
</div>
